import List from "./List";
import Update from "./Update";

export const Contact = {
  List: List,
  Update: Update,
  Permissions: {
    read: "read:Form",
    list: "list:Form",
    delete: "delete:Form",
    update: "update:Form-slug-contato",
  },
};
